<template>
    <div id="app"  >
    <div ref="view"></div>
    <dHead :navIsWhite="navIsWhite"/>
    <!-- <transition name="fade" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <SideService @scrollToTop="scrollToTop" :showSide="showSide"/>
    </transition> -->
      <router-view />
          <div class="login" v-show="isShowLogin">
            <div class="box"> 
              <div class="boxTitle">
                阿里钉钉联合蓝凌推出中小企智能OA
              </div>
              <div class="boxDesc">
                50+细分行业，10000+品牌企业都在用，欢迎免费体验
              </div>
              <div class="boxHead">
                <div :class="loginWay == 1 ? 'active':''" @click="loginWay=1">新用户快速体验</div>
                <p class="bLine"></p>
                <div :class="loginWay == 2 ? 'active':''" @click="loginWay=2">老用户快速登录</div>
              </div>
              <div class="boxCon">

                <div>
                  <span class="err">*</span>
                  <span>手机</span>
                  <input type="tel" placeholder="  请输入" v-model="tel" maxlength="11">
                  <span class="err" v-show="errTel">{{errTel}}</span>
                </div>
                <div class="code">
                  <span class="err">*</span>
                  <span>验证码</span>
                  <input placeholder="  请输入" v-model="code" maxlength="6">
                  <div class="but" @click="getCode" v-if="codeTime == 0">获取验证码</div>
                  <div class="but stop" v-if="codeTime>0">
                    {{codeTime}}s后再次发送
                  </div>
                  <span class="err" v-show="errCode">{{errCode}}</span>

                </div>
                <div v-show="loginWay == 1">
                  <span class="err">*</span>
                  <span>姓名</span>
                  <input type="text" placeholder="  请输入" v-model="username" maxlength="10">
                  <span class="err" v-show="errName">{{errName}}</span>
                </div>
                <div v-show="loginWay == 1">
                  <span class="err">*</span>
                  <span>企业</span>
                  <input type="text" placeholder="  请输入" v-model="company" maxlength="20">
                  <span class="err" v-show="errComp">{{errComp}}</span>

                </div>
                <div v-show="loginWay == 1">
                  <span>&nbsp;&nbsp;</span>
                  <span>邮箱</span>
                  <input type="email" placeholder="  请输入" v-model="useremail" maxlength="20">

                </div>
              </div>
              <div class="errMessage">{{errMessage}}</div>

              <div class="boxFoot" @click="toLogin">
                免费体验
              </div>
              <div class="closeIcon" @click="isShowLogin=false">
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
    <div class="toast" v-if="toast">{{toast}}</div>

    <Floating v-if="!$route.meta.isApply"/>
    <CopyRight />
  </div>
</template>

<script>
import dHead from './components/d-header'
import CopyRight from './components/copyRight'
import Floating from './components/floating'
// import SideService from './components/sideService'
import './font/font.css'
import Vue from 'vue'
export default {
  name: 'App',
  data() {
    return {
        navIsWhite : false,
        showSide : false,
        Hub:new Vue({}),
        isShowLogin:false,
        errMessage:'',
        tel:"",               //用户数据
        code:'',
        username:"",
        company:"",
        useremail:"",
        loginWay:1,         //登录方式
        errTel:'',          //错误信息
        errName:'',
        errComp:'',
        errCode:'',
        codeTime:0,
        toast:'',
        lwfrom:'0'
    }
  },
  components:{dHead,CopyRight, Floating},
  created() {
    this.$root.$on('change',(val)=>{
        this.showLogin(val)
    })
    //获取lwfrom
    var reg = new RegExp("(^|&)lwfrom=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if(r){
      this.lwfrom = r[2];
      if(this.lwfrom == 'landray'){
        this.showLogin(true)
      }
    }else{
      var item = this.$route.query
      if(item && item.lwfrom){
          this.lwfrom = item.lwfrom
          if(this.lwfrom == 'landray'){
            this.showLogin(true)
          }
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.appScroll);
  },
  methods:{
    appScroll() {
      this.navIsWhite = (document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset) > 0 ? true : false;
      if((document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset) > 500) {
        this.showSide = true;
      }else{
        this.showSide = false
      }
    },
    scrollToTop() {
      this.$refs.view.scrollIntoView();
    },

    getCode(){
      this.isPhone()
      if(this.errTel){
        return;
      }
      let params = {phone:this.tel}
      this.$ajax({
        method:'POST',
        url:'https://ding.dingteam.com/operation/f4/verifycode',
        data:params,
      }).then((res)=>{
        if(res.data.errCode == 0){
          this.toast = '发送成功'
          setTimeout(()=>{
            this.toast = ''
          },1500)
        }else{
          this.errMessage = res.data.msg;
          setTimeout(()=>{
            this.errMessage = ''
          },2000)
        }

        this.codeTime = 60;
        let timer = setInterval(()=>{
          this.codeTime -= 1
          if(this.codeTime <= 0 ){
            clearInterval(timer);
          }
        },1000)
      }).catch(err=>{console.log(err)})
    },
    toLogin(){
      this.isPhone()
      if(this.loginWay==1){
        if (this.username == "" || !this.username) {
          this.errName = "不能为空"
          setTimeout(() => {
            this.errName = '' 
          }, 3000);
        } 
        if (this.company == "" || !this.company) {
          this.errComp = "不能为空"
          setTimeout(() => {
            this.errComp = '' 
          }, 3000);
        }
        if (this.code == "" || !this.code) {
          this.errCode = "不能为空"
          setTimeout(() => {
            this.errCode = '' 
          }, 3000);
        }
        if(this.errTel || this.errName || this.errComp || this.errCode){
          return;
        }
        let params ={
          "phone":this.tel,
          "name":this.username,
          "corp_name":this.company,
          "email":this.useremail,
          "lwfrom":this.lwfrom,
          'origin_url':window.location.href,
          "verify_code":this.code
        }
        this.$ajax({
          method:'POST',
          url:' https://ding.dingteam.com/operation/f4/v2/register',
          data:params
        }).then(res=>{
          console.log(res);
          if(res.data.errCode == 0){
            this.toast = '注册成功'
            setTimeout(()=>{
              this.toast = ''
            },1500)
            var date = new Date().getTime();
            let dateTime = date + (86400000 * 14);
            localStorage.setItem('token', res.data.data.token)
            localStorage.setItem('d_user_phone', this.tel)
            let userData = {
              "phone":this.tel,
              "token":res.data.data.token,
            }
            this.$ajax({
              method:'POST',
              url:' https://ding.dingteam.com/operation/f4/getTicket',
              data:userData
            }).then((res)=>{
              if(res.data.errCode == 0){
                window.location.href = 'https://d.dingoa.com/go/demo/'+res.data.data.ticket; 
                // window.open('https://d.dingoa.com/go/demo/'+res.data.data.ticket,'_blank')
              }else{
                  this.toast = '登陆失败'
                  setTimeout(()=>{
                      this.toast = ''
                  },1500)
              }
            }).catch(err=>{console.log(err);})
          }else{
            this.errMessage = res.data.msg;
            setTimeout(() => {
              this.errMessage = '' 
            }, 3000);
          }
        }).catch(err=>{console.log(err)})
      }else{
        if(this.errTel){
            return;
        }
        let params={ 
          "phone":this.tel,
          // "lwfrom":this.lwfrom,
          "verify_code":this.code
        }
        this.$ajax({
          method:'POST',
          url:' https://ding.dingteam.com/operation/f4/login',
          data:params
        }).then(res=>{
          if(res.data.errCode == 0){
            this.toast = '正在跳转'
            var date = new Date().getTime();
            let dateTime = date + (86400000 * 14);
            localStorage.setItem('token', res.data.data.token)
            localStorage.setItem('d_user_phone', this.tel)
            let userData = {
              "phone":this.tel,
              "token":res.data.data.token,
            }
            this.$ajax({
              method:'POST',
              url:' https://ding.dingteam.com/operation/f4/getTicket',
              data:userData
            }).then((res)=>{
              if(res.data.errCode == 0){
                this.toast = ''
                window.location.href = 'https://d.dingoa.com/go/demo/'+res.data.data.ticket;  
                // window.open('https://d.dingoa.com/go/demo/'+res.data.data.ticket,'_blank')
              }else{
                  this.toast = ''
                  this.errMessage="跳转登陆失败"
                  setTimeout(()=>{
                      this.errMessage = ''
                  },2000)
              }
            }).catch(err=>{console.log(err);})
          }else{
            this.errMessage = res.data.msg
            setTimeout(() => {
              this.errMessage = '' 
            }, 3000);
          }
        }).catch(err=>{console.log(err);})
      }

    },
    isPhone(){
      if (this.tel == "" || !this.tel) {
        this.errTel = "不能为空"
        setTimeout(() => {
          this.errTel = '' 
        }, 3000);
      }else if (!(/^1[345789]\d{9}$/.test(this.tel))) {
        this.errTel = "号码有误"
        setTimeout(() => {
          this.errTel = ''
        }, 3000);
      }
    },
    showLogin(val){
      var tok = localStorage.getItem('token')
      var tel = localStorage.getItem('d_user_phone')
      if( tok && tel ){
        this.toast='自动登录中'
        let userData = {
          "phone":tel,
          "token":tok,
        }
        this.$ajax({
          method:'POST',
          url:' https://ding.dingteam.com/operation/f4/getTicket',
          data:userData
        }).then((res)=>{
          if(res.data.errCode == 0){
            setTimeout(() => {
              this.toast = '' 
            }, 2500);
            window.location.href = 'https://d.dingoa.com/go/demo/'+res.data.data.ticket; 
            // window.open('https://d.dingoa.com/go/demo/'+res.data.data.ticket,'_blank')
          }else{
              this.toast = '请手动登录'
              setTimeout(()=>{
                      this.toast = ''
              },2500)
              localStorage.removeItem('token');
              localStorage.removeItem('d_user_phone');
              this.isShowLogin = val;
          }
        }).catch(err=>{this.isShowLogin = val})
      }else{
        this.isShowLogin = val;
      }
    },
  },
  destroyed () {
    window.removeEventListener('scroll', this.appScroll); 
}

}
</script>

<style>
#app{
  margin:0 auto;
}
.btn{
  background: pink;
  widows: 100px;
  height:100px;
  position:fixed;
  top:50%;
  right:20px;
}

/* .app{
  position:absolute;
  top:0;
  bottom: 0;
  overflow: scroll;
  width:100%;
} */

</style>
<style lang="less">
.login{
  position: fixed;
  width: 100%;
  height:100%;
  left: 0;
  top: 0;
  background: rgba(0,0,0,.4);
  z-index: 99;
  animation: fadeIn 1s;
  .box{
    .boxTitle{
      text-align: center;
      font-size:22px;
      font-weight:500;
      color:rgba(0,0,0,0.85);
      line-height:30px;
      margin-right: 50px;
    }
    .boxDesc{
      text-align: center;
      font-size:14px;
      color:rgba(0,0,0,0.65);
      line-height:20px;
      margin: 4px 0 32px;
      margin-right: 50px;
    }
    position: relative;
    background: #ffffff;
    margin: 50px auto;
    position:relative;
    width:574px;
    height:588px;
    box-shadow:0px 6px 10px 0px rgba(2,3,5,0.2);
    border-radius:4px;
    border:1px solid rgba(151,151,151,1);
    padding-left: 50px;
    padding-top: 36px;
    font-family:PingFangSC-Regular,PingFang SC;
    .boxHead{
      display: flex;
      font-weight:400;
      color:rgba(0,0,0,0.45);
      line-height:38px;
      margin-bottom: 25px;
      >div{
        cursor: pointer;
        width:150px;
        height:38px;
        background:rgba(255,255,255,1);
        border-radius:0 4px 4px 0px;
        border:1px solid rgba(0,0,0,0.15);
        text-align: center;
        &:first-child{
          border-radius:4px 0px 0px 4px;
          border-right: none;
        }
        &:nth-of-type(2){
          border-left: none;
        }
      }
      .bLine{
        width: 1px;
        background: rgba(95,139,236,1);
      }
      .active{
        border-color:rgba(95,139,236,1);
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(95,139,236,1);
      }
    }
    .boxCon{
      color:rgba(25,31,37,1);
      >div{
        margin-bottom: 20px;
        position: relative;
        &:nth-last-child(1){
          margin-bottom: 10px;
        }
        .err{
          font-weight:500;
          color:rgba(241,85,51,1);
        }
        input{
          width: 350px;
          height: 40px;
          border-radius:4px;
          border:1px solid rgba(0,0,0,0.1);
          margin-left: 10px;
          padding-left: 10px;
        }
      }

      .code{
        margin-left: -16px;
        input{
        }
        .but{
          display: inline-block;
          color: #5A87FF;
          position: absolute;
          font-size: 13px;
          right: 130px;
          top: 12px;
          cursor: pointer;
        }
        .stop{
          cursor:text;
          color: #666666;
        }
      }
    }
    .boxFoot{
      width:160px;
      height:42px;
      background:linear-gradient(315deg,rgba(95,139,236,1) 0%,rgba(95,139,236,1) 100%);
      box-shadow:0px 6px 2px 0px rgba(4,35,85,0.1);
      border-radius:8px;
      font-size:20px;
      color:rgba(255,255,255,1);
      line-height:42px;
      text-align: center;
      cursor: pointer;
      position:absolute;
      bottom: 42px;
      left: 50%;
      transform: translateX(-80px)
    }
  }

  .errMessage{
    color:rgba(241,85,51,1);margin-right:50px;text-align:center;height:16px;
  }
}
.closeIcon{
  width: 18px;
  height: 18px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
    span{
      display: inline-block;
      width: 18px;
      height: 1.5px;
      background-color: #666666;
      position: absolute;
      top: 8px;
      left: 0px;
      &:nth-child(1){
        transform: rotate(45deg)
      }
      &:nth-child(2){
        transform: rotate(-45deg)
      }
    }
    &:hover{
      span{
        height: 2px;
      }
    };
}
.toast{
  width:130px;
  height:50px;
  background: rgba(0,0,0,.6);
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  border-radius: 5px;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin:auto;
  z-index: 999;
}
// #newBridge .nb-invite-body{
//   display: none!important;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue